import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkConfig } from 'app/providers/StoreProvider';
import { UserProfile } from 'entities/User';

export const fetchUser = createAsyncThunk<
    UserProfile,
    void,
    ThunkConfig<string>
>('user/fetchUser', async (_, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.get<UserProfile>(`/v1/users/me`);

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
